<div class="col-12" *ngIf="filtered.length < (cNotizen.length+ lNotizen.length)" (click)="toggleShowArchived()"
    style="cursor: pointer;">
    {{((cNotizen.length+ lNotizen.length) - filtered.length )}} archivierte Notizen anzeigen
</div>
<app-notiz *ngFor="let notiz of filtered" [notiz]="notiz"></app-notiz>